var _defs, _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagDotFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M32.706 17.294c-.045.014-5.998.338-11.729-3.754-5.458-3.897-9.733-1.142-9.733-1.142v11.657s3.918-4.278 11.255-2.409c7.337 1.869 10.208-4.353 10.207-4.353z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M11.244 7.487v29.758"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M7.828 37.245h6.833"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 11.244,
    cy: 6.575,
    r: 2.29
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 11.244,
    cy: 6.575,
    r: 2.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDotFilled);
export default __webpack_public_path__ + "static/media/flagDotFilled.ba5b3a5f84e49910c1ae95055b6f4c71.svg";
export { ForwardRef as ReactComponent };